import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_ACC001_Request,
  IAPI_ACC001_Response,
  IAPI_ACC012_Request,
  IAPI_ACC012_Response,
  IAPI_ACC010_Request,
  IAPI_ACC010_Response,
} from "../../../type/apiType";

/**
 * 機構ユーザ参照
 * @return httpWamUserRefer
 */
const httpAPI_ACC010 = async (
  param: IAPI_ACC010_Request
): Promise<IAPI_ACC010_Response> => {
  const res = await http.post(ApiUrl.API_ACC010, {
    ...param,
  });

  return res.data;
};

/**
 * 機構ユーザ更新
 * @return httpWamUserUpdate
 */
const httpAPI_ACC012 = async (
  param: IAPI_ACC012_Request
): Promise<IAPI_ACC012_Response> => {
  const res = await http.post(ApiUrl.API_ACC012, {
    ...param,
  });

  return res.data;
};

/**
 * ユーザアカウント失効化
 * @return httpUserRevoke
 */
const API_ACC001 = async (
  param: IAPI_ACC001_Request
): Promise<IAPI_ACC001_Response> => {
  const res = await http.post(ApiUrl.API_ACC001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_ACC010, httpAPI_ACC012, API_ACC001 };
